// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wq_a bih_b bih_we"};